import { DealerDetails } from '../DealerDetails/DealerDetails';
import { PaymentDetails } from '../PaymentDetails/PaymentDetails';
import { SaleDetails } from '../SaleDetails/SaleDetails';

import styles from './SaleDetailsView.scss';

export const SaleDetailsView = () => (
  <div className={styles.saleDetailsView}>
    <SaleDetails />
    <DealerDetails />
    <PaymentDetails />
  </div>
);
